package com.eladfinish.bible.contest.screens.search.ai

data class AiSearchSuggestion(
    val expression: String,
    val explanation: String? = null,
)
